import ajax from '../utils/ajax';
import { formatImage } from '../utils/index'
import loadImageToTexture from './loadImageToTexture'
let color = ['#86B755', '#000000', '#ffffff', '#eeff00'];

function formatModelFilePath(path) {
    if (!path) {
        return '';
    }
    if (/^https?:\/\//i.test(path) || path.startsWith('//')) {
        return path;
    }
    return formatImage(path);
}

function parseJsonSafely(input) {
    if (!input) {
        return null;
    }
    try {
        return typeof input === 'string' ? JSON.parse(input) : input;
    } catch (error) {
        return null;
    }
}

async function loadResource(id) {
    const response = await ajax.get('/admin/materialManage/getById', { params: { id } });
    if (response.code === 401) {
        throw new Error('登录已失效，请重新扫码进入作品');
    }
    if ((response.code && response.code !== 200) || !response.data) {
        throw new Error('素材信息加载失败，请重试');
    }
    let sourceData = response.data;
    const parsedDetail = parseJsonSafely(sourceData.detail);
    const isGlbResource =
        sourceData.classifyId1 === 1 &&
        sourceData.modelFilePath &&
        /\.glb$/i.test(sourceData.modelFilePath);
    const resourceRenderType = isGlbResource ? 'glb' : 'sprite';
    const parsedModelConfig = parseJsonSafely(sourceData.modelConfigJson)
        || (parsedDetail && parsedDetail.modelConfig)
        || {};
    let sourceDataDetail = isGlbResource
        ? {
            format: 'glb',
            url: formatModelFilePath(sourceData.modelFilePath),
            defaultScale: (parsedDetail && parsedDetail.defaultScale) || sourceData.defaultScale || 90,
            stem: (parsedDetail && parsedDetail.stem) || {
                color: '#4d6840',
                radiusStem: 2,
            },
            flower: (parsedDetail && parsedDetail.flower) || {
                radiusTop: '18',
                radiusBottom: '18',
                height: '28',
                color: '#6d8f5b',
            },
            modelConfig: parsedModelConfig,
        }
        : parsedDetail;

    if (sourceData.classifyId1 === 1 && !isGlbResource) {
        // Deduplicate within this resource only; ownership remains unchanged.
        const imagePromises = new Map();
        const loadTexture = item => {
            const url = formatImage(item.url);
            if (!imagePromises.has(url)) {
                imagePromises.set(url, loadImageToTexture(url));
            }
            return imagePromises.get(url);
        };
        for (let key in sourceDataDetail.angles) {
            sourceDataDetail.angles[key] = sourceDataDetail.angles[key].singles;
            const item = sourceDataDetail.angles[key];
            const res = [];
            // Bound requests/decodes instead of starting every face at once.
            for (let start = 0; start < item.length; start += 4) {
                try {
                    res.push(...await Promise.all(item.slice(start, start + 4).map(loadTexture)));
                } catch (error) {
                    console.warn('Material texture load failed', { resourceId: id, url: error.imageUrl, reason: error.message });
                    imagePromises.forEach(promise => promise.then(result => result.texture.dispose(), () => {}));
                    throw new Error(`素材“${sourceData.name || id}”图片加载失败，请检查网络后重试`);
                }
            }
            for (let faceKey in res) {
                item[faceKey].texture = res[faceKey].texture;
                item[faceKey].width = res[faceKey].width;
                item[faceKey].height = res[faceKey].height;
            }
            if (item.length === 1) {
                item.push({
                    ...item[0],
                    turn: true
                })
            }

        }

    }

    sourceData.detail = null;
    return {
        ...sourceData,
        type: sourceData.classifyId1,
        resourceRenderType,
        isGlbResource,
        detail: sourceDataDetail
    }
}


export default loadResource;
